export default "__VITE_ASSET__D5282boF__"